import request from "./../utils/request";

export function createScreenshot(website) {
    return request({
        url: "/screenshot/",
        method: "post",
        data: { website },
    });
}
